<template>
  <div>
    <!-- {{ Paydatas }} -->
    <table
      class="table table-sm table-bordered"
      style="background: #fff; widows: 100%;"
    >
      <thead>
        <tr>
          <th>{{ $t("Сумма") }}</th>
          <th>{{ $t("Скидка") }}</th>
          <th style="width: 105px;">{{ $t("Тўлов тури") }}</th>
          <th>{{ $t("Изоҳ") }}</th>
          <th style="width: 100px;">{{ $t("Сана") }}</th>
          <th style="width: 43px;"></th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="(item, index) in Paydatas"
          :key="index"
          :class="{ bg: index % 2 == 1 }"
        >
          <td
            v-if="
              ShowModalKey == false || ShowModalKey == item.key || ShovTable
            "
          >
            {{ item.summa | numFormat }}
          </td>
          <td
            v-if="
              ShowModalKey == false || ShowModalKey == item.key || ShovTable
            "
          >
            {{ item.discount | numFormat }}
          </td>
          <td
            v-if="
              ShowModalKey == false || ShowModalKey == item.key || ShovTable
            "
          >
            {{ item.pay_type }}
          </td>
          <td
            v-if="
              ShowModalKey == false || ShowModalKey == item.key || ShovTable
            "
          >
            {{ item.comment }}
          </td>
          <td
            v-if="
              ShowModalKey == false || ShowModalKey == item.key || ShovTable
            "
          >
            {{ item.date_time | dateFormatDD }}
            <!-- <date-picker
                        style="width: 200px;"
                        id="tugkun"
                        v-model="item.date_time"
                        format="DD MM HH:mm:ss"
                        value-type="X"
                        type="date"
                        :lang="lang"
                  ></date-picker> -->
          </td>
          <td
            :class="{
              Arxive: $route.name == 'ArxivOne' || $route.name == 'Arxivlar'
            }"
            v-if="
              ShowModalKey == false || ShowModalKey == item.key || ShovTable
            "
          >
            <b-button
              style="width: 30px; height: 30px; display: flex; justify-content: center;"
              @click="deleteSumma(item, index)"
              variant="outline-danger"
              v-if="Number(item.date_time) > dateDeleted && localUser && localUser.role == 'Admin'"
            >
              <b-icon style="width: 17px;" icon="trash"></b-icon>
            </b-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
export default {
  props: ["Paydatas", "ShowModalKey", "ShovTable"],
  components: {
    DatePicker
  },
  data() {
    return {
      localUser: JSON.parse(localStorage.getItem("user")),
      dateDeleted: Math.floor(new Date().getTime() / 1000) - 1440 * 60,
      lang: {
        formatLocale: {
          firstDayOfWeek: 1
        },
        monthBeforeYear: true
      }
    };
  },
  filters: {
    dateFormatDD: function(date) {
      if (date) {
        return moment.unix(date).format("DD.MM HH:mm");
      } else {
        return "";
      }
    }
  },
  methods: {
    deleteSumma(item, index) {
      this.$emit("deleteSumma", item, index);
    },
    SortKEy() {
      if (ShowModalKey) {
      }
    }
  }
};
</script>
<style></style>
